@if (!isModern) {
<div>
  <div #monerisResponse></div>
  <div class="cardIcon">
    <img class="mc"
         src="/assets/images/masterdcard_128.png"
         alt="MasterCard Icon">
    <img class="visa"
         src="/assets/images/visa_128.png"
         alt="Visa Icon">
  </div>
    <div class="cc-container">
      <!--
      https://help.fullstory.com/hc/en-us/articles/360044349073-Fullstory-Private-by-Default#:~:text=fs%2Dexclude%20),diagonal%20grey%20and%20white%20stripes.
      -->
        <iframe #monerisFrame
            [src]="monerisUrl"
            class="fs-exclude"
            frameborder="0"
            width="300px"
            height="220px"></iframe>
     </div>
  <div>
    <button mat-raised-button
            color="primary"
            [disabled]="disabledSubmit || !canSubmit"
            (click)="doMonerisSubmit()">{{ submitLabel || ('shoppingCart.payment.proceedWithPayment' | translate) }}</button>
  </div>
</div>
} @else {
<div class="modern-payment">
  <div #monerisResponse></div>
  <div class="modern-card-icons">
    <img src="/assets/images/masterdcard_128.png"
         alt="MasterCard">
    <img src="/assets/images/visa_128.png"
         alt="Visa">
  </div>
  <div class="modern-cc-container">
    <!--
    https://help.fullstory.com/hc/en-us/articles/360044349073-Fullstory-Private-by-Default#:~:text=fs%2Dexclude%20),diagonal%20grey%20and%20white%20stripes.
    -->
    <iframe #monerisFrame
        [src]="monerisUrl"
        class="fs-exclude"
        frameborder="0"
        width="100%"
        height="175px"
        [title]="'shoppingCart.payment.modern.frameTitle' | translate"></iframe>
  </div>
  <ul class="modern-field-hints">
    <li><strong>{{ 'shoppingCart.payment.modern.cardNumberShort' | translate }}</strong> {{ 'shoppingCart.payment.modern.cardNumberHint' | translate }}</li>
    <li><strong>{{ 'shoppingCart.payment.modern.expirationDateShort' | translate }}</strong> {{ 'shoppingCart.payment.modern.expirationDateHint' | translate }}</li>
    <li><strong>{{ 'shoppingCart.payment.modern.securityCodeShort' | translate }}</strong> {{ 'shoppingCart.payment.modern.securityCodeHint' | translate }}</li>
  </ul>

  <ng-content></ng-content>

  <div class="modern-actions">
    <button mat-flat-button
            color="primary"
            class="modern-submit"
            [disabled]="disabledSubmit || !canSubmit"
            (click)="doMonerisSubmit()">{{ submitLabel || ('shoppingCart.payment.proceedWithPayment' | translate) }}</button>
    <ng-content select="[odqPaymentActions]"></ng-content>
  </div>
</div>
}
